/** Pull a human-readable string out of a failed API call.
 *
 * Backend 4xx bodies come in two shapes: ``detail: "<code or prose>"``
 * and ``detail: {reason, message, …}`` (e.g. the seat-limit 409s).
 * Components that render the rejection directly crash React on the
 * object shape ("Objects are not valid as a React child") — route it
 * through here instead. Falls back to the transport error's message.
 */
export function extractApiDetail(err: unknown): string {
  const detail = (
    err as { response?: { data?: { detail?: unknown } } } | null
  )?.response?.data?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (detail && typeof detail === "object") {
    const d = detail as { message?: unknown; reason?: unknown };
    if (typeof d.message === "string" && d.message) return d.message;
    if (typeof d.reason === "string" && d.reason) return d.reason;
  }
  if (err instanceof Error && err.message) return err.message;
  return String(err);
}
